export const checkIfStringStartsWith = (str, array) =>{
    return array.some(substr => str.startsWith(substr));
}